import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html'
})
export class ForgetPasswordComponent implements OnInit {
  forgetPassForm: FormGroup = new FormGroup({});
  loading = false;
  msgObj: any = {msg: [], type: ''};
  captcha = '';
  formSubmitted = false;

  constructor(
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    private router: Router
    ) { }

  ngOnInit() {
    this.forgetPassForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'),
      ])
    });
  }

  forgetPassword() {
    this.formSubmitted = true;
    if (this.forgetPassForm.valid && this.captcha) {
      this.loading = true;
      this.authenticationService.forgetPassword(this.forgetPassForm.controls['email'].value).subscribe(() => {
           this.loading = false;
           this.msgObj.msg = [this.translate.instant('auth.Send-successfully-check-email')];
           this.msgObj.type = 'success';
           Swal.fire({
             title: this.translate.instant('swalMsg.Success'),
             text: this.translate.instant('auth.Send-successfully-check-email'),
             icon: 'success',
             confirmButtonText: this.translate.instant('swalMsg.Ok'),
           }).then(() => {
            this.router.navigate(['/']);
           });
        },
        (error: any) => {
          this.loading = false;
          this.msgObj.type = 'danger';
          this.msgObj.msg = error.result.errorMessages;
          // if (error && error.code === -1) {
          //   this.msgObj.msg = this.translate.instant('forms.email-not-correct');
          // } else {
          //   this.msgObj.msg = this.translate.instant('forms.Try-again');
          //   // this.msgObj.msg = this.translate.instant('forms.email-not-correct');
          // }
        });
    }
  }

  hasError(controlName: string, errorName: string) {
    return this.forgetPassForm.controls[controlName].hasError(errorName);
  }
}
